import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'formatComponentType'
})
export class FormatComponentTypePipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return '';
        // Insertar espacios antes de mayúsculas y capitalizar cada palabra
        return value
            .replace(/([a-z])([A-Z])/g, '$1 $2') // separa camelCase
            .replace(/^./, str => str.toUpperCase()); // capitaliza la primera letra
    }
}
